/**
 * Created by fworld on 2019/10/8.
 */
import request from '@/util/request'

export const makePictureCreate = (data) => {
    return request({
        'url': '/api/v1/delivery/makePicture/create',
        'method': 'post',
        data
    })
}

export const makePictureUpdate = (data) => {
    return request({
        'url': '/api/v1/delivery/makePicture/update',
        'method': 'post',
        data
    })
}

export const makePictureList = () => {
    return request({
        'url': '/api/v1/delivery/makePicture/list',
        'method': 'get',
    })
}

export const makePictureDeviceUnion = (params) => {
    return request({
        'url': '/api/v1/delivery/makePicture/device/union',
        'method': 'get',
        params
    })
}

export const makePictureDeviceList = (params) => {
    return request({
        'url': '/api/v1/delivery/makePicture/device/list',
        'method': 'get',
        params
    })
}

export const makePictureDeviceBind = (data) => {
    return request({
        'url': '/api/v1/delivery/makePicture/device/bind',
        'method': 'post',
        data
    })
}

export const makePictureDeviceUnBind = (params) => {
    return request({
        'url': '/api/v1/delivery/makePicture/device/unbind',
        'method': 'get',
        params
    })
}
